interface IIntegerValidatorProps {
  errorMessage: string;
  digitsCount: number;
}
export function isDigitsCountCorrect({
  errorMessage,
  digitsCount,
}: IIntegerValidatorProps): (value?: string) => string | undefined {
  return (value?: string) => {
    if (!value) {
      return undefined;
    }
    const regex = new RegExp(`^[\\d+]{${digitsCount}}$`);

    return regex.test(value) ? undefined : errorMessage;
  };
}
